import React from "react"
import Relay from "react-relay"
import { get } from "lodash/object"
import { Link } from "react-router"
import { FormattedMessage, injectIntl } from "react-intl"
import ArticleFeature from "../modules/ArticleFeature"
import sharedMessages from "../../messages/index"
import settingsMessages from "../../messages/settings"
import { getAccountSettings } from "../../scripts/accountSettings"
import Image from "../elements/Image"
import classNames from "classnames"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"

class Home extends React.Component {
  state = { features: [] }

  getShuffledFeatures = () => {
    return ["top_left", "top_right", "bottom_left"].reduce(
      (features, name, i) => {
        const edges = get(this.props, `viewer.${name}.edges`, false)
        const edge = edges[Math.floor(Math.random() * edges.length)]

        if (edge) {
          features.push({ resource: edge.node, name: name })
        }

        return features
      },
      []
    )
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    // We can't run this server side without causing a flash @see  mytours/curtis/issues/679
    this.setState({ features: this.getShuffledFeatures() })
  }

  componentWillUnmount() {
    if (this.shuffleInterval) {
      clearTimeout(this.shuffleInterval)
    }
  }

  render() {
    const { features } = this.state
    const {
      settings: {
        style: { content: styleType },
        static_texts: { welcome: welcomeMessage }
      },
      name: siteName
    } = getAccountSettings(
      this.props.intl.formatMessage(settingsMessages.authenticAccountId)
    )

    return (
      <main id="main" role="main" tabIndex={0} data-article-style="single">
        {getStyleTag([
          "showcase-grid__item--any",
          "showcase-grid__image",
          "showcase-grid__link",
          "data-article-type-flag",
          "data-article-type-icon"
        ])}
        <div className="showcase-grid">
          <article
            className="showcase-grid__item showcase-grid__item--hero"
            style={getStyles("showcase-grid__item")}
            data-article-type="hero"
          >
            <Link to="/search" className="showcase-grid__link flag-mask">
              {getStyleTag("showcase-grid__image--welcome")}
              <div
                className="showcase-grid__image"
                style={getStyles("showcase-grid__image--welcome")}
              />
              <div
                className="flag"
                style={getStyles("showcase-grid__item--hero__flag")}
              >
                <div className="flag__content">
                  <h3>
                    {welcomeMessage || (
                      <FormattedMessage
                        {...sharedMessages.welcome}
                        values={{ siteName }}
                      />
                    )}
                  </h3>
                </div>
              </div>
            </Link>
          </article>

          {features.map((feature, i) => (
            <ArticleFeature
              key={`${feature.resource.id}-${i}`}
              className={classNames(`showcase-grid__item--${feature.name}`)}
              style={getStyles("showcase-grid__item--any")}
              resource={feature.resource}
            />
          ))}

          {styleType === "default" ? (
            <article
              className="showcase-grid__item showcase-grid__item--bottom_right showcase-grid__item--logo showcase-grid__item--logo--centered"
              style={getStyles("showcase-grid__item")}
              data-article-type="unspecified"
            >
              <a
                href="https://citylibrary.pncc.govt.nz/"
                target="_blank"
                className="showcase-grid__link flag-mask"
              >
                <div
                  className="showcase-grid__image"
                  style={{ backgroundImage: "url('images/pncc-logo-bg.jpg')" }}
                >
                  <Image alt={siteName} src="images/pncc-library-logo.svg" />
                </div>
                <div className="flag">
                  <div className="flag__content">
                    <h3>&nbsp;</h3>
                  </div>
                </div>
              </a>
            </article>
          ) : null}
        </div>
      </main>
    )
  }
}

export default Relay.createContainer(injectIntl(Home), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        top_right: resources(first: 10 custom_fields: "{\\"feature_location\\": \\"top_right\\"}" access_rights: "published" orphan: true ) {
          edges {
            node {
              ${ArticleFeature.getFragment("resource")}
            }
          }
        }
        top_left: resources(first: 10 custom_fields: "{\\"feature_location\\": \\"top_left\\"}" access_rights: "published" orphan: true ) {
          edges {
            node {
              ${ArticleFeature.getFragment("resource")}
            }
          }
        }
        bottom_left: resources(first: 10 custom_fields: "{\\"feature_location\\": \\"bottom_left\\"}" access_rights: "published" orphan: true ) {
          edges {
            node {
              ${ArticleFeature.getFragment("resource")}
            }
          }
        }
      }
    	`
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/Home.js